module.exports = __webpack_public_path__ + "static/media/diaper-throught.a12aad38.png";